module.exports = __webpack_public_path__ + "img/_qft_.5fa1033a.svg";